/**************************************************
 * Nombre:       Proceso_Compra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import agave from '../../../../Recursos/Temporales/agave.svg'
import linea from '../../../../Recursos/linea.svg'
import {InventoryOutlined, LocalShippingOutlined, SavedSearch, StarOutlined} from '@mui/icons-material'
import logos from "../../../../Recursos/logos.png";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Proceso_Compra = () => {
    const {sCell} = useResponsive()

    const Paso = ({item}) => {
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <item.icono color={'primary'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography>{item.nombre}</Typography>
                </Grid>

            </Grid>
        )
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{maxWidth: '1400px', px: sCell ? 0 : 3}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <img src={logos} width={'100%'} height={'auto'}/>
            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#F3FFFF',
                    p: 4,
                    mt: 2

                }}
            >

                <Grid container size={{xs: 2, sm: 1, md: 1}} sx={{justifyContent: 'flex-start', mt: -2}}>
                    <img src={agave} alt="Agave" width={40} height={'auto'}/>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 10, sm: 11, md: 11}}
                    sx={{pl: 2, pb: 2}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600, fontSize: 16}}>
                            Proceso de Compra
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 400, fontSize: 14, color: '#00000050', lineHeight: 1.1}}>
                            Queremos darte la mejor experiencia de compra online, por esto simplificamos los pasos para
                            que
                            sea mas sencillo para ti
                        </Typography>
                    </Grid>


                </Grid>


                <Grid container size={{xs: 3, sm: 1.5, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                    <Paso item={items[0]}/>
                </Grid>

                {!sCell &&
                    <Grid container size={{xs: 3, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                        <img src={linea} width={'100%'} height={'auto'}/>
                    </Grid>
                }

                <Grid container size={{xs: 3, sm: 1.5, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                    <Paso item={items[1]}/>
                </Grid>

                {!sCell &&
                    <Grid container size={{xs: 3, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                        <img src={linea} width={'100%'} height={'auto'}/>
                    </Grid>
                }

                <Grid container size={{xs: 3, sm: 1.5, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                    <Paso item={items[2]}/>
                </Grid>

                {!sCell &&
                    <Grid container size={{xs: 3, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                        <img src={linea} width={'100%'} height={'auto'}/>
                    </Grid>
                }

                <Grid container size={{xs: 3, sm: 1.5, md: 1.5}} sx={{justifyContent: 'flex-start'}}>
                    <Paso item={items[3]}/>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Proceso_Compra

const items = [
    {
        nombre: 'Escoge',
        icono: SavedSearch
    },
    {
        nombre: 'Compra',
        icono: InventoryOutlined
    },
    {
        nombre: 'Recibe',
        icono: LocalShippingOutlined
    },
    {
        nombre: 'Disfruta',
        icono: StarOutlined
    },
]